import React, { useContext } from "react";
import { merge } from "lodash-es";
import { Site } from "api/typedefs/Site";
import { Bible } from "api/typedefs/Bible";

const { REACT_APP_IMAGE_BUCKET } = process.env;
const IMAGES_URL = `https://${REACT_APP_IMAGE_BUCKET ||
  "global-bible-images-prod"}.s3.amazonaws.com/`;

// siteUtils start
export const defaultSite: Site = {
  appStoreName: "",
  appStoreSubtitle: "",
  bibleFont: "",
  bibles: [] as Bible[],
  createdAt: 0,
  customDomain: "",
  description: "",
  domain: "",
  googleAnalyticsId: "",
  host: "",
  iconImage: `03784422-65c9-4409-b301-1115f14932bd_global-bible-logo-mark-wt.svg`,
  installedName: "",
  keywords: "",
  linkAppStore: "",
  linkDonate: "",
  linkFacebook: "",
  linkPlayStore: "",
  linkTwitter: "",
  linkWebsite: "",
  logoImage: `03784422-65c9-4409-b301-1115f14932bd_global-bible-logo-mark-wt.svg`,
  primaryColor: "#0C68F1",
  primaryLanguage: "eng",
  published: true,
  scriptDirection: "LTR",
  secondaryColor: "#FFFFFF",
  secondaryLanguage: "",
  showBibleAbbreviations: "",
  storeDescription: "",
  subdomain: "",
  title: "",
  uiFont: "",
  updatedAt: 0,
  includeAllBibles: false,
  enabledUserAccounts: false
};

export const normalizeSite = (rawSite: object) => {
  const site = merge({ ...defaultSite }, rawSite);

  if (site.logoImage) {
    site.logoImage = IMAGES_URL + site.logoImage;
  }
  if (site.iconImage) {
    site.iconImage = IMAGES_URL + site.iconImage;
  }

  return site;
};

// siteUtils end

// context start
export const SiteConfigContext = React.createContext(defaultSite);
export const SiteConfigProvider: React.FC<{ site: object }> = ({
  site = {},
  children
}) => (
  <SiteConfigContext.Provider value={normalizeSite(site)}>
    {children}
  </SiteConfigContext.Provider>
);
export const SiteConfigConsumer = SiteConfigContext.Consumer;
export const useSiteConfig = () => useContext(SiteConfigContext);
// context end
